import React, { useEffect, useState } from "react";
import { useRefreshTick } from "@/lib/autoRefresh";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatRupiah } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Landmark, ChevronRight } from "lucide-react";

export function CompanyBillsPanel() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [data, setData] = useState(null);

  const tick = useRefreshTick();
  useEffect(() => {
    api.get("/dashboard/company-bills").then((r) => setData(r.data)).catch(() => {});
  }, [tick]);

  if (!data || data.items.length === 0) return null;
  const toReport = user?.role !== "staf_tagihan";
  const open = (id) => navigate(toReport ? `/laporan?tab=vendor&company=${id}` : `/vendor-bills?pt=${id}`);

  return (
    <Card className="p-4" data-testid="company-bills-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <Landmark className="h-4 w-4 text-brand" />
          <h3 className="font-semibold" style={{ fontFamily: "Outfit" }}>Tagihan Belum Dibayar per PT</h3>
        </div>
        <p className="text-xs text-muted-foreground">Total <span className="font-mono font-semibold text-brand" data-testid="company-bills-total">{formatRupiah(data.total)}</span></p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
        {data.items.map((c) => (
          <button key={c.id} onClick={() => open(c.id)} data-testid={`company-card-${c.id}`}
            className="group text-left rounded-xl border bg-white p-3.5 hover:border-brand/50 hover:shadow-md transition-[box-shadow,border-color] duration-200">
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold text-sm truncate">{c.name}</p>
              <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 group-hover:translate-x-0.5 transition-transform" />
            </div>
            <p className="text-[11px] font-mono text-muted-foreground truncate">{c.account_number ? `Rek. ${c.account_number}` : "—"}</p>
            <p className={`text-lg font-bold font-mono mt-1.5 ${c.unpaid_total > 0 ? "text-rose-600" : "text-brand"}`} data-testid={`company-card-${c.id}-total`}>{formatRupiah(c.unpaid_total)}</p>
            <p className="text-[11px] text-muted-foreground">{c.count} tagihan belum dibayar</p>
          </button>
        ))}
      </div>
    </Card>
  );
}
